/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/AdvertismentPictures/SippenSauseBG.png";
import LogoDrinkandPlayicon from "assets/images/Logo/SippenSause/Logo.png";
import SippenSauseImageGallery from "./sections/SippenSauseImageGallery";

function SippenSause() {
  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
          mb: 4,
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} mt={15} mb={10} justifyContent="center" mx="auto">
            <Card
              sx={{
                backgroundColor: () => `rgba(255, 255, 255, 0.9)`,
                borderRadius: "15px",
                p: 6,
                boxShadow: 3,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <MKTypography
                variant="h1"
                color="black"
                textAlign="center"
                mb={4}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                SippenSause{" "}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="black"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={2}
                mb={4}
              >
                Das ultimative Trinkspiel für deine Party!
              </MKTypography>
            </Card>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 4,
          mx: { xs: 3, lg: 6 },
          mt: -10, // Increased negative margin to create more overlap
          mb: 6,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MKTypography variant="h3" mb={4}>
                Spiele SippenSause
              </MKTypography>
              <MKTypography variant="body2" color="text" mb={4}>
                SippenSause ist das perfekte Partyspiel für dich und deine Freunde. Mit
                verschiedenen Aufgaben und Minispielen wird es garantiert nicht langweilig! Lade es
                jetzt kostenlos im Google Play Store herunter.
              </MKTypography>
              <MKButton
                variant="gradient"
                color="info"
                size="large"
                component="a"
                href="https://play.google.com/store/apps/details?id=com.lkgameart.sippensause"
                target="_blank"
                sx={{ mb: 3 }}
              >
                Jetzt im Play Store herunterladen
              </MKButton>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <MKBox
                    component="img"
                    src={LogoDrinkandPlayicon}
                    alt="SippenSause App Icon"
                    width="100%"
                    height="auto"
                    sx={{
                      borderRadius: "60px",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Card>
      <Card
        sx={{
          p: 4,
          mx: { xs: 3, lg: 6 },
          mb: 6,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <SippenSauseImageGallery />
      </Card>
      <MKBox pt={8} px={3} mt={8}>
        {/* Increased padding and margin */}
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default SippenSause;
